'use client';

import { c as _c } from "react/compiler-runtime";
import useModalStore from '@module/stores/useModalStore';
import { useEffect, useState } from 'react';
import './NotificationMenu.scss';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { cn } from '@module/lib/utils';
import { useAlarmIsRead } from '@module/queries/alarm/alarmQueryHooks';
import { useASPInfo } from '@module/queries/asp/query';
import useIsMounted from '@module/utils/useIsMounted';
import BaseButton from '@pc/components/atoms/button/BaseButton';
export function NotificationMenu() {
  const $ = _c(19);
  const {
    isLogin
  } = useGetLoginInfoQuery();
  const {
    pushModal
  } = useModalStore();
  let t0;
  if ($[0] !== pushModal) {
    t0 = () => {
      pushModal({
        type: "NOTIFICATION_MODAL",
        id: "NotificationMenu"
      });
    };
    $[0] = pushModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const ModalHandler = t0;
  const [isAlarm, setIsAlarm] = useState(true);
  let t1;
  if ($[2] !== isLogin) {
    t1 = {
      enabled: isLogin,
      retry: false
    };
    $[2] = isLogin;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data
  } = useAlarmIsRead(t1);
  let t2;
  if ($[4] !== data?.isRead || $[5] !== isLogin) {
    t2 = () => {
      if (!isLogin) {
        setIsAlarm(true);
      } else {
        setIsAlarm(!!data?.isRead);
      }
    };
    $[4] = data?.isRead;
    $[5] = isLogin;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== data || $[8] !== isLogin) {
    t3 = [isLogin, data];
    $[7] = data;
    $[8] = isLogin;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  const {
    data: siteInfo
  } = useASPInfo();
  if (!useIsMounted()) {
    return null;
  }
  if (siteInfo) {
    return;
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      content: "\uC54C\uB9BC\uD568"
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = !isAlarm;
  let t6;
  if ($[11] !== t5) {
    t6 = cn("box", {
      active: t5
    });
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="h-[36px] w-[36px] bg-50% bg-icon-notify bg-position-center bg-size-24 bg-no-repeat" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6) {
    t8 = <div className={t6}>{t7}</div>;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== ModalHandler || $[17] !== t8) {
    t9 = <><div className="notification"><BaseButton tooltip={t4} variant="ghost" size="none" className="flex h-[48px] w-[48px] items-center justify-center rounded-full hover:bg-menuHover focus:outline-none" onClick={ModalHandler}>{t8}</BaseButton></div></>;
    $[16] = ModalHandler;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}